import { createReducer, on } from '@ngrx/store';
import { DashboardsActions, RouterActions, AppActions } from '@actions/index'
import { LocationModel } from '@models/locations.model';
import { emptyLocationModel, emptyContactsQueueModel, emptyCampaignMetricsPerLocationModel } from '@utilities/data-utils';
import { ContactQueuesModel, CampaignMetricsPerLocationModel, IncomingReviewSeriesModel, SentVsPendingModel, FinishCampaignModel } from '@models/index';

export interface State {
    businessDashboardLocation: LocationModel,
    businessDashboardReviewsAmount: number,
    businessDashboardFeedbacksAmount: number,
    businessDashboardContactsAmount: number,
    businessRating: number,
    businessStarsCount: number[],
    businessReviewCount: number,
    businessUserCount: number,
    businessContactCount: number,
    businessLocationCount: number,
    locationQueues: ContactQueuesModel,
    locationCampaignMetrics: CampaignMetricsPerLocationModel,
    locationTodaySeries: IncomingReviewSeriesModel,
    locationLastWeekSeries: IncomingReviewSeriesModel,
    locationLastMonthSeries: IncomingReviewSeriesModel,
    locationReviewRequestTodaySeries: IncomingReviewSeriesModel,
    locationReviewRequestLastWeekSeries: IncomingReviewSeriesModel,
    locationReviewRequestLastMonthSeries: IncomingReviewSeriesModel,
    locationSentVsPending: SentVsPendingModel,
    locationFinishCampaign: FinishCampaignModel,
    lastDayReviewCount: number,
    lastWeekReviewCount: number,
    lastMonthReviewCount: number,
    resellerBusinessCount: number,
    resellerUserCount: number,
    resellerLocationCount: number,
    siteAdminResellerCount: number,
    siteAdminBusinessCount: number,
    siteAdminUserCount: number,
    siteAdminLocationCount: number,
    error: string
}

const initialState: State = {
    businessDashboardLocation: emptyLocationModel(),
    businessDashboardReviewsAmount: 0,
    businessDashboardFeedbacksAmount: 0,
    businessDashboardContactsAmount: 0,
    businessRating : 0,
    businessStarsCount : [0,0,0,0,0],
    businessReviewCount: 0,
    businessUserCount: 0,
    businessContactCount: 0,
    businessLocationCount: 0,
    locationQueues: emptyContactsQueueModel(),
    locationCampaignMetrics:emptyCampaignMetricsPerLocationModel(),
    locationTodaySeries:{ data: [] },
    locationLastWeekSeries:{ data: [] },
    locationLastMonthSeries:{ data: [] },
    locationReviewRequestTodaySeries:{ data: [] },
    locationReviewRequestLastWeekSeries:{ data: [] },
    locationReviewRequestLastMonthSeries:{ data: [] },
    locationSentVsPending:{ Active: 0, InQueue: 0 },
    locationFinishCampaign:{ days: 0, hours: 0, minutes: 0, seconds: 0 },
    lastDayReviewCount: 0,
    lastWeekReviewCount: 0,
    lastMonthReviewCount: 0,
    resellerBusinessCount: 0,
    resellerUserCount: 0,
    resellerLocationCount: 0,
    siteAdminResellerCount: 0,
    siteAdminBusinessCount: 0,
    siteAdminUserCount: 0,
    siteAdminLocationCount: 0,
    error: ''

};

export const reducer = createReducer(
    initialState,
    on(DashboardsActions.setBusinessDashboardLocation, (state, { location }) => ({ ...state, businessDashboardLocation: location })),
    on(DashboardsActions.searchBusinessReviewsAmountByLocationSuccess, (state, { businessDashboardReviewsAmount }) => ({ ...state, businessDashboardReviewsAmount })),
    on(DashboardsActions.searchBusinessFeedbacksAmountByLocationSuccess, (state, { businessDashboardFeedbacksAmount }) => ({ ...state, businessDashboardFeedbacksAmount })),
    on(DashboardsActions.searchBusinessContactsAmountByLocationSuccess, (state, { businessDashboardContactsAmount }) => ({ ...state, businessDashboardContactsAmount })),
    on(DashboardsActions.getBusinessRatingSuccess, (state, { businessRating }) => ({ ...state, businessRating })),
    on(DashboardsActions.getBusinessStarsCountSuccess, (state, {businessStarsCount}) => ({ ...state, businessStarsCount})),
    on(DashboardsActions.getBusinessReviewCountSuccess, (state, { businessReviewCount }) => ({ ...state, businessReviewCount })),
    on(DashboardsActions.getBusinessUserCountSuccess, (state, { businessUserCount }) => ({ ...state, businessUserCount })),
    on(DashboardsActions.getBusinessContactCountSuccess, (state, { businessContactCount }) => ({ ...state, businessContactCount })),
    on(DashboardsActions.getBusinessLocationCountSuccess, (state, { businessLocationCount }) => ({ ...state, businessLocationCount })),
    on(DashboardsActions.searchLocationContactsQueuesSuccess, (state, {locationQueues}) => ({ ...state,locationQueues})),
    on(DashboardsActions.searchLocationCampaignMetricsSuccess, (state, {locationCampaignMetrics}) => ({ ...state,locationCampaignMetrics})),
    on(DashboardsActions.searchLocationTodaySeriesSuccess, (state, {locationTodaySeries}) => ({ ...state,locationTodaySeries})),
    on(DashboardsActions.searchLocationLastWeekSeriesSuccess, (state, {locationLastWeekSeries}) => ({ ...state,locationLastWeekSeries})),
    on(DashboardsActions.searchLocationLastMonthSeriesSuccess, (state, {locationLastMonthSeries}) => ({ ...state,locationLastMonthSeries})),
    on(DashboardsActions.searchLocationReviewRequestTodaySeriesSuccess, (state, {locationTodaySeries}) => ({ ...state,locationReviewRequestTodaySeries: locationTodaySeries})),
    on(DashboardsActions.searchLocationReviewRequestLastWeekSeriesSuccess, (state, {locationLastWeekSeries}) => ({ ...state,locationReviewRequestLastWeekSeries: locationLastWeekSeries})),
    on(DashboardsActions.searchLocationReviewRequestLastMonthSeriesSuccess, (state, {locationLastMonthSeries}) => ({ ...state,locationReviewRequestLastMonthSeries: locationLastMonthSeries})),
    on(DashboardsActions.searchLocationSentVsPendingSuccess, (state, {locationSentVsPending}) => ({ ...state,locationSentVsPending})),
    on(DashboardsActions.searchLocationFinishCampaignSuccess, (state, {locationFinishCampaign}) => ({ ...state,locationFinishCampaign})),
    on(DashboardsActions.getLastDayReviewCountSuccess, (state, { lastDayReviewCount }) => ({ ...state, lastDayReviewCount })),
    on(DashboardsActions.getLastWeekReviewCountSuccess, (state, { lastWeekReviewCount }) => ({ ...state, lastWeekReviewCount })),
    on(DashboardsActions.getLastMonthReviewCountSuccess, (state, { lastMonthReviewCount }) => ({ ...state, lastMonthReviewCount })),
    on(DashboardsActions.getResellerBusinessCountSuccess, (state, {resellerBusinessCount}) => ({ ...state,resellerBusinessCount})),
    on(DashboardsActions.getResellerUserCountSuccess, (state, {resellerUserCount}) => ({ ...state,resellerUserCount})),
    on(DashboardsActions.getResellerLocationCountSuccess, (state, {resellerLocationCount}) => ({ ...state,resellerLocationCount})),
    on(DashboardsActions.getSiteAdminResellerCountSuccess, (state, {siteAdminResellerCount}) => ({ ...state, siteAdminResellerCount})),
    on(DashboardsActions.getSiteAdminBusinessCountSuccess, (state, {siteAdminBusinessCount}) => ({ ...state, siteAdminBusinessCount})),
    on(DashboardsActions.getSiteAdminUserCountSuccess, (state, {siteAdminUserCount}) => ({ ...state, siteAdminUserCount})),
    on(DashboardsActions.getSiteAdminLocationCountSuccess, (state, {siteAdminLocationCount}) => ({ ...state, siteAdminLocationCount})),
    on(AppActions.clearState, () => ({ ...initialState })),
    on(DashboardsActions.dashboardsError, (state, { error }) => ({ ...state, error: error })),
    on(RouterActions.navigateAuth, () => ({ ...initialState })),
);

export const getBusinessDashboardLocation = (state: State) => state.businessDashboardLocation
export const getBusinessDashboardReviewsAmount = (state: State) => state.businessDashboardReviewsAmount
export const getBusinessDashboardFeedbacksAmount = (state: State) => state.businessDashboardFeedbacksAmount
export const getBusinessDashboardContactsAmount = (state: State) => state.businessDashboardContactsAmount
export const getBusinessRating = (state: State) => state.businessRating;
export const getBusinessStarsCount = (state: State) => state.businessStarsCount;
export const getBusinessReviewCount = (state: State) => state.businessReviewCount;
export const getBusinessUserCount = (state: State) => state.businessUserCount;
export const getBusinessContactCount = (state: State) => state.businessContactCount;
export const getBusinessLocationCount = (state: State) => state.businessLocationCount;
export const getLocationQueues = (state: State) => state.locationQueues;
export const getLocationCampaignMetrics = (state: State) => state.locationCampaignMetrics;
export const getLocationTodaySeries = (state: State) => state.locationTodaySeries;
export const getLocationLastWeekSeries = (state: State) => state.locationLastWeekSeries;
export const getLocationLastMonthSeries = (state: State) => state.locationLastMonthSeries;
export const getLocationReviewRequestTodaySeries = (state: State) => state.locationReviewRequestTodaySeries;
export const getLocationReviewRequestLastWeekSeries = (state: State) => state.locationReviewRequestLastWeekSeries;
export const getLocationReviewRequestLastMonthSeries = (state: State) => state.locationReviewRequestLastMonthSeries;
export const getLocationSentVsPending = (state: State) => state.locationSentVsPending;
export const getLocationFinishCampaign = (state: State) => state.locationFinishCampaign;
export const getLastDayReviewCount = (state: State) => state.lastDayReviewCount;
export const getLastWeekReviewCount = (state: State) => state.lastWeekReviewCount;
export const getLastMonthReviewCount = (state: State) => state.lastMonthReviewCount;
export const getresellerBusinessCount = (state: State) => state.resellerBusinessCount;
export const getresellerUserCount = (state: State) => state.resellerUserCount;
export const getresellerLocationCount = (state: State) => state.resellerLocationCount;
export const getSiteAdminResellerCount = (state: State) => state.siteAdminResellerCount;
export const getSiteAdminBusinessCount = (state: State) => state.siteAdminBusinessCount;
export const getSiteAdminUserCount = (state: State) => state.siteAdminUserCount;
export const getSiteAdminLocationCount = (state: State) => state.siteAdminLocationCount;
export const getError = (state: State) => state.error;
